import { ProjectConstructionType } from "@/web-client/api";

export const AllProjectConstructionTypes = [
  ProjectConstructionType.NEW,
  ProjectConstructionType.RENOVATION,
];
